module.exports = __webpack_public_path__ + "static/media/iconEdit.8e5f6042.svg";